import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PharmacieEditComponent } from './pharmacie-edit/pharmacie-edit.component';
import {ReactiveFormsModule} from '@angular/forms';
import { OrdonnanceEtatComponent } from './ordonnance-etat/ordonnance-etat.component';


@NgModule({
  declarations: [
    PharmacieEditComponent,
    OrdonnanceEtatComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    PharmacieEditComponent,
    OrdonnanceEtatComponent
  ]
})
export class FormModule { }
